import ReportFilterDropdown from "@/reports/components/ReportFilterDropdown";

const ActivityFilter = () => {
  const defaultOption = { value: "", label: "All activity" };

  const MOCK_MENU_OPTIONS = [
    defaultOption,
    { value: "true", label: "Assigned activity" },
    { value: "false", label: "Independent activity" },
  ];

  return (
    <ReportFilterDropdown
      menuOptions={MOCK_MENU_OPTIONS}
      defaultOption={defaultOption}
      label="Activity"
      urlSearchParam="only_assigned_content"
      eventTrackingDescription="Teacher Reporting - activity filter"
    />
  );
};

export default ActivityFilter;
